module.exports = __webpack_public_path__ + "img/pic.b402c9e3.png";